<script lang="ts" setup>
import { useAuthStore } from "@/stores/auth";

const authStore = useAuthStore();

function login() {
  authStore.login();
}
</script>

<template>
  <v-container class="pa-0 login">
    <header>
      <h1 class="large">Welkom bij de<br />Paris Proof Monitor</h1>
    </header>
    <article>Het intelligente dataplatform voor overzicht en inzicht in uw vastgoed en de meest effectieve verduurzamingsroute.</article>
    <footer>
      <v-row>
        <v-col class="d-flex justify-center">
          <v-btn @click="login" color="primary">
            <v-icon start>mdi-arrow-right</v-icon>
            Inloggen
          </v-btn>
        </v-col>
      </v-row>
    </footer>
  </v-container>
</template>
